"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var SnackbarContainer = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Snackbar__SnackbarContainer",
  componentId: "sc-11gteje-0"
})(["position:fixed;justify-content:space-between;background-color:", ";z-index:20000;bottom:", "px;left:50%;transform:translate(-50%,0);max-width:560px;border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,0.2),0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[1];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[3];
});

var Snackbar = function Snackbar(_ref3) {
  var content = _ref3.content,
      isVisible = _ref3.isVisible,
      action = _ref3.action,
      label = _ref3.label,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 9 / 10 : _ref3$width,
      _ref3$p = _ref3.p,
      p = _ref3$p === void 0 ? 3 : _ref3$p;
  return isVisible && _react["default"].createElement(SnackbarContainer, {
    alignItems: "center",
    p: p,
    width: width
  }, content && _react["default"].createElement(_Text["default"], {
    color: "light.0",
    fontSize: 3
  }, content), action && label && _react["default"].createElement(_Button["default"], {
    variant: "outline.primary.0",
    onClick: action
  }, label));
};

var _default = Snackbar;
exports["default"] = _default;